/**
 * Supplier Master — Grid uses ERPAdvancedGrid + Custom form with tabs
 */
import React, { useState, useEffect, useCallback } from 'react';
import ERPAdvancedGrid from '../../../components/erp/ERPAdvancedGrid';
import SupplierMasterForm from './SupplierMasterForm';
import '../../../styles/erp-theme.css';
import { API_BASE as API_URL, getToken} from '../../../lib/api';


const GRID_COLS = [
  { field: 'Vend_uid', header: 'SUPPLIER ID', visible: true },
  { field: 'Vend_name', header: 'SUPPLIER NAME', visible: true },
  { field: 'vend_sname', header: 'SHORT NAME', visible: true },
  { field: 'vend_type', header: 'TYPE', visible: true },
  { field: 'ContactPerson', header: 'CONTACT', visible: true },
  { field: 'panno', header: 'PAN NO', visible: true },
  { field: 'StateId', header: 'STATE', visible: true },
];

const SupplierMasterScreen = ({ theme = 'light' }) => {
  const [view, setView] = useState('grid');
  const [editData, setEditData] = useState(null);
  const [formMode, setFormMode] = useState('add');
  const [token, setToken] = useState('');
  useEffect(() => { setToken(getToken() || ''); }, []);

  if (view === 'form') return <SupplierMasterForm token={token} editData={editData} mode={formMode} onGridView={() => { setView('grid'); setEditData(null); }} onSaved={() => setView('grid')} />;

  return <SupplierGrid token={token} onAddNew={() => { setEditData(null); setFormMode('add'); setView('form'); }} onEdit={(row, mode) => { setEditData(row); setFormMode(mode || 'edit'); setView('form'); }} />;
};

const SupplierGrid = ({ token, onAddNew, onEdit }) => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortField, setSortField] = useState('');
  const [sortDir, setSortDir] = useState('desc');
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const p = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
      if (sortField) { p.set('sortField', sortField); p.set('sortDir', sortDir); }
      Object.entries(filters).forEach(([k, v]) => { if (v) p.set(`filter${k}`, v); });
      const r = await fetch(`${API_URL}/api/masters/supplier?${p}`, { headers: { Authorization: `Bearer ${token}` } });
      const j = await r.json();
      if (j.success) { setData(j.data || []); setTotal(j.total || 0); }
    } catch {}
    setLoading(false);
  }, [page, pageSize, sortField, sortDir, filters, token]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleSort = (f) => {
    if (sortField === f) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortField(f); setSortDir('asc'); }
    setPage(1);
  };

  const handleVoid = async (row) => {
    if (!window.confirm(`Void "${row.Vend_name}"?`)) return;
    await fetch(`${API_URL}/api/masters/supplier/${row.Vend_uid}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    loadData();
  };

  return (
    <ERPAdvancedGrid
      title="Supplier Master"
      columns={GRID_COLS}
      data={data}
      total={total}
      idField="Vend_uid"
      nameField="Vend_name"
      page={page}
      pageSize={pageSize}
      onPageChange={setPage}
      onPageSizeChange={(s) => { setPageSize(s); setPage(1); }}
      sortField={sortField}
      sortDir={sortDir}
      onSort={handleSort}
      filters={filters}
      onFilterChange={(f) => { setFilters(f); setPage(1); }}
      loading={loading}
      onAddNew={onAddNew}
      onEdit={onEdit}
      onVoid={handleVoid}
      testId="supplier-master"
      exportFileName="SupplierMaster"
    />
  );
};

export default SupplierMasterScreen;
